import { useContext } from 'react';
import { VisitContext } from '@context';

export const useVisitContext = () => {
  const context = useContext(VisitContext);
  return context;
};
